import { BootcampChallengeStep } from "@Constants/bootcamp";
import MetricFilterTypes from "@Enums/MetricFilterTypes";

export interface BootcampStepConfig {
  progress: number;
  metric?: MetricFilterTypes;
  translationKey: string;
}

const BOOTCAMP_STEPS: Partial<Record<BootcampChallengeStep, BootcampStepConfig>> = {
  [BootcampChallengeStep.PASSING_BASICS]: { progress: 1, translationKey: "passing-basics" },
  [BootcampChallengeStep.DECISION_MAKING]: { progress: 2, metric: MetricFilterTypes.DECISION, translationKey: "decision-making" },
  [BootcampChallengeStep.SCAN_RATE]: { progress: 3, metric: MetricFilterTypes.SCAN_FREQUENCY, translationKey: "scan-rate" },
  [BootcampChallengeStep.SCAN_TIMING]: { progress: 4, metric: MetricFilterTypes.SCAN_TIMING, translationKey: "scan-timing" },
  [BootcampChallengeStep.AWARENESS]: { progress: 5, metric: MetricFilterTypes.AWARENESS, translationKey: "awareness" },
  [BootcampChallengeStep.CRITICAL_SCAN]: { progress: 6, metric: MetricFilterTypes.CRITICAL_SCAN, translationKey: "critical-scan" },
  [BootcampChallengeStep.FINAL]: { progress: 7, metric: MetricFilterTypes.BYB_IQ, translationKey: "final" },
};

export const getBootcampStep = (challengeStep?: BootcampChallengeStep | null) => (challengeStep ? BOOTCAMP_STEPS[challengeStep] : undefined);
